import _assign from "object-assign";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import deepmerge from 'deepmerge';

var createLevels = function createLevels(shadows) {
  return {
    flat: {
      boxShadow: 'none'
    },
    1: {
      boxShadow: shadows[1]
    },
    2: {
      boxShadow: shadows[2]
    },
    3: {
      boxShadow: shadows[3]
    },
    4: {
      boxShadow: shadows[4]
    },
    5: {
      boxShadow: shadows[5]
    },
    6: {
      boxShadow: shadows[6]
    },
    7: {
      boxShadow: shadows[7]
    },
    8: {
      boxShadow: shadows[8]
    },
    9: {
      boxShadow: shadows[9]
    },
    10: {
      boxShadow: shadows[10]
    },
    11: {
      boxShadow: shadows[11]
    },
    12: {
      boxShadow: shadows[12]
    }
  };
};

var createOptions = function createOptions(levels) {
  return {
    flat: levels.flat,
    black: {
      1: levels[1],
      2: levels[2],
      3: levels[3],
      4: levels[4],
      5: levels[5],
      6: levels[6]
    },
    blue: {
      1: levels[7],
      2: levels[8],
      3: levels[9],
      4: levels[10],
      5: levels[11],
      6: levels[12]
    }
  };
};

var createGetElevation = function createGetElevation(options) {
  return function () {
    var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'black';
    var hasOwnProperty = Object.prototype.hasOwnProperty;

    if (!hasOwnProperty.call(options, variant)) {
      return undefined;
    }

    var levelByVariant = hasOwnProperty.call(options[variant], level) ? options[variant][level] : {};
    return level === 0 ? options.flat : levelByVariant;
  };
};

export var createElevation = function createElevation(shadows) {
  var elevation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref = typeof elevation === 'function' ? elevation(shadows) : elevation,
      otherGetElevation = _ref.getElevation,
      otherOptions = _objectWithoutProperties(_ref, ["getElevation"]);

  var levels = createLevels(shadows);
  var options = createOptions(levels);
  var mergedOptions = deepmerge(options, otherOptions, {
    clone: false
  });
  return _assign({
    getElevation: otherGetElevation || createGetElevation(mergedOptions)
  }, mergedOptions);
};